import { render } from "./PandoraBorder.vue?vue&type=template&id=d6f3a822"
import script from "./PandoraBorder.vue?vue&type=script&lang=js"
export * from "./PandoraBorder.vue?vue&type=script&lang=js"

import "./PandoraBorder.vue?vue&type=style&index=0&id=d6f3a822&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__